var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15819",
    "data-name": "Group 15819",
    transform: "translate(-1051 -187)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4084",
    "data-name": "Ellipse 4084",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1051 187)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30269",
    "data-name": "Path 30269",
    d: "M5.736,12.736V8.265H1.265a1.265,1.265,0,0,1,0-2.53H5.736V1.264a1.265,1.265,0,0,1,2.529,0V5.735h4.471a1.265,1.265,0,0,1,0,2.53H8.265v4.471a1.265,1.265,0,0,1-2.529,0Z",
    transform: "translate(1065.9 192) rotate(45)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close_btn.fe9143cf3fef87d2048c76e3d2da97de.svg";
export { ForwardRef as ReactComponent };